import React from "react";
import styled from "styled-components";

const Container = styled.div`
  margin-left: 16px;
`;

export const HorizontalValue = ({ children }) => {
  return <Container>{children}</Container>;
};
